import { Component, OnInit,ElementRef, Inject, } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from "@angular/material/dialog";
import { brandList } from "../../../_model/brand/brand";


@Component({
  selector: 'app-brand-chooser',
  templateUrl: './brand-chooser.component.html',
  standalone: true,
  imports: [MatDialogModule],
  styleUrls: ['./brand-chooser.component.scss']
})
export class BrandChooserComponent implements OnInit {
  public brandLists!: brandList[];
  constructor(private matDialogRef: MatDialogRef<BrandChooserComponent, brandList>,
    @Inject(MAT_DIALOG_DATA) private data: { brands: brandList[]; trigger: ElementRef }) { }

  ngOnInit() {
    this.brandLists = this.data.brands;
    //console.log("brand",this.data)
    // console.log("brand",this.data.brands)
    //console.log("brandLists",this.brandLists)


    const rect = this.data.trigger.nativeElement.getBoundingClientRect();
    this.matDialogRef.updatePosition({left: `${rect.left}px`, top: `${rect.bottom + 13}px`});
  }

  updateBrandList(brandList: brandList) {
    this.matDialogRef.close(brandList);
  }
}
